<template>
	<div id="app" class="main-wrapper">
		<router-view />
	</div>
</template>

<script>
export default {
	data() {
		return {}
	},
	created() {},
}
</script>

<style lang="less">
* {
	margin: 0;
	padding: 0;
}

#app {
	font-family: Avenir, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #fff;
	padding: 0;
	margin: 0;
	box-sizing: border-box;
	background: #fff;
	overflow: auto;
}
.main-wrapper {
	height: 100vh;
	min-width: 1440px;
	min-height: 600px;
	position: relative;
}

/*包含以下四种的链接*/
a {
	text-decoration: none;
}
/*正常的未被访问过的链接*/
a:link {
	text-decoration: none;
}
/*已经访问过的链接*/
a:visited {
	text-decoration: none;
}
/*鼠标划过(停留)的链接*/
a:hover {
	text-decoration: none;
}
/* 正在点击的链接*/
a:active {
	text-decoration: none;
}
</style>
